export default "__VITE_ASSET__84984388__"